<template>
    <div class="training-main class-information" v-if="body_show">
        <h2 class="title">同学你好，我是《7天职业发展特训营》课程的班班，我将和古典老师一起，带你进行未来7天的学习，希望能支持你取得期待的职业突破！</h2>
        <h2 class="title2">在上课前，请同学务必花【2分钟】时间填写下方表单，我会根据大家的情况，对课程各部分详略程度做一些微调，并选取一些典型问题做分析答疑。</h2>
        <div class="form_grouping">
            <div class="nickName">
                <label class="title">微信昵称</label>
                <label class="name" v-if="user.nickname">{{user.nickname}}</label>
            </div>
            <!-- 行业职业 -->
            <van-cell-group class="grouping">
                <van-field placeholder="请填写您的行业职业"  v-model="info.job" label="行业职业"  />
            </van-cell-group>
            <!-- 工作年限 -->
            <van-cell-group class="grouping">
                <div lang="select-group">
                    <van-field placeholder="请选择工作年限"  v-model="info.workage" label="工作年限" @click="pickerType('workage_group')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </div>
            </van-cell-group>
            <!-- 课程期待 -->
            <div class="style_tags mt">
                <h2>我目前在职业发展中面临的难题是？<small>(最多选2项)</small></h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.problem">
                        <van-checkbox :class="[problem_group &&problem_group.length-1==index?'last-checkbox':'']"  v-for="(item,index) in problem_group" :key="index"  :disabled="!info.problem.includes(item) && info.problem&& info.problem.length>=2" :name="item">
                            <span>{{item}}</span>
                            <van-field v-if="item.includes('其它')" :disabled="info.problem &&  !info.problem.includes('其它')" @click="addCheckbox('problem',$event)"  class="training-other"  v-model="problem_name"   />
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 我未来半年至一年的职业发展目标是？ -->
            <div class="style_tags mt">
                <h2>我未来半年至一年的职业发展目标是？<small>(最多选2项)</small></h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.target">
                        <van-checkbox :class="[target_group && target_group.length-1==index?'last-checkbox':'']"  v-for="(item,index) in target_group" :key="index"  :disabled="!info.target.includes(item) && info.target &&  info.target.length>=2" :name="item">
                            <span>{{item}}</span>
                            <van-field v-if="item.includes('其它')" :disabled="info.target && !info.target.includes('其它')" @click="addCheckbox('target',$event)"  class="training-other"  v-model="target_name"   />
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 我当前工作的月收入是： -->
            <van-cell-group class="grouping mt">
                <h4 class="h4">我当前工作的月收入是：</h4>
                <div lang="select-group">
                    <van-field placeholder="请选择我当前工作的月收入"  v-model="info.income"  @click="pickerType('income_group')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </div>
                <van-cell-group v-if="info.income.includes('其它')" class="grouping">
                    <van-field placeholder="请填写当前工作的月收入"  v-model="income_name"  />
                </van-cell-group>
            </van-cell-group>
            <!-- 我未来半年至一年的月收入目标是： -->
            <van-cell-group class="grouping mt">
                <h4 class="h4">我未来半年至一年的月收入目标是：</h4>
                <div lang="select-group">
                    <van-field placeholder="请选择我未来半年至一年的月收入目标"  v-model="info.target_income"  @click="pickerType('target_income_group')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </div>
                <van-cell-group v-if="info.target_income.includes('其它')" class="grouping">
                    <van-field placeholder="请填写未来半年至一年的月收入目标"  v-model="target_income_name"  />
                </van-cell-group>
            </van-cell-group>
            <!-- 我和新精英的熟悉程度 -->
            <div class="style_tags mt">
                <h2>我和新精英的熟悉程度<small>（多选）</small></h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.familiar">
                        <van-checkbox  :class="[familiar_group && familiar_group.length-1==index?'last-checkbox':'']" v-for="(item,index) in familiar_group" :key="index"  :name="item">
                            <span>{{item}}</span>
                            <van-field v-if="item.includes('其它')" :disabled="info.familiar &&  !info.familiar.includes('其它')"  @click="addCheckbox('familiar',$event)" class="training-other"  v-model="familiar_name"   />
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 是否愿意担任组长 -->
            <div class="style_tags mt">
                <h2>是否愿意担任组长，带领小组完成目标？担任组长，配合完成小组工作，组长责任：鼓励小组成员，配合完成考勤，提升小组任务达成率。</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="info.leader">
                        <van-radio :class="{'last-radio':(leader_group && leader_group.length-1)==index}"  v-for="(item,index) in leader_group" :key="index" :name="item">
                            <span>{{item}}</span>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div>
            <!-- 愿意担任组长 -->
            <div v-if="info.leader=='愿意'" class="style_tags mt">
                <h2>我担任组长的优势？每期优秀完成当期组长工作的组长将获得古典老师的人生破局课，和后续课程的大力度优惠。<small>（多选）</small></h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="info.advantage">
                        <van-checkbox  :class="[advantage_group && advantage_group.length-1==index?'last-checkbox':'']" v-for="(item,index) in advantage_group" :key="index"  :name="item">
                            <span>{{item}}</span>
                            <van-field v-if="item.includes('其它')" :disabled="info.advantage &&  !info.advantage.includes('其它')"  @click="addCheckbox('advantage',$event)" class="training-other"  v-model="advantage_name"   />
                        </van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 其他我想告诉班班的: -->
            <van-cell-group class="grouping mt">
                <h4 class="h4">其他我想告诉班班的:</h4>
                <van-field class="class_info_textarea" placeholder="请填写您想告诉班班的" type="textarea"  v-model="info.others"/>
            </van-cell-group>
            <!-- 提交 -->
            <a :class="['btn',validation?'on':'']" @click="submitHandle()" type="default">提交</a>
        </div>
        <van-popup v-model="picker_show" position="bottom">
            <van-picker  show-toolbar :columns="columns[picker_type]"    @cancel="picker_show=false" @confirm="confirm" />
        </van-popup>
    </div>
</template>

<script>
import areaList  from '@/utils/area'
import { getFormSubmit,updateFormSubmit } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
export default {
    data() {
        return{
            body_show:false,
            picker_show:false,
            user:{},
            picker_type:'',
            columns:{
                // 工作年限
                workage_group:['学生'],
                // 当前收入
                income_group:[
                    '5000以下',
                    '5000-10000元',
                    '10000-15000元',
                    '15000-20000元',
                    '20000-30000元',
                    '30000元以上'
                ],
                // 目标收入
                target_income_group:[
                    '5000以下',
                    '5000-10000元',
                    '10000-15000元',
                    '15000-20000元',
                    '20000-30000元',
                    '30000元以上'
                ],
            },
            // 我目前在职业发展中面临的难题
            problem_group:[
                '【没方向】感觉很迷茫，不知道该做啥？',
                '【有危机】裁员寒冬，担心没有核心竞争力',
                '【发展慢】薪资/发展不如预期，没朋友、同学发展快',
                '【遇瓶颈】当前方向没上升空间，想转型没思路/有困难',
                '【难平衡】多重角色无法兼顾，如何平衡？',
                '没遇到太多问题，就是想来学习/体验一下',
                '其它'
            ],
            // 熟悉程度
            familiar_group:[
                '不认识新精英，无意间看到课程来参加的',
                '了解新精英，第一次参加新精英的课程',
                '读过古典老师的书和专栏，《拆墙》《可能》《跃迁》《超级个体》',
                '学习过《个人战略-商业模式重塑课》',
                '学习过《自我探索-最佳工作模式课》',
                '学习过《生涯规划师》系列课程',
                '其它'
            ],
            // 我未来半年至一年的职业发展目标
            target_group:[
                '【晋升】在当前领域晋升到高一级岗位',
                '【求职】求职/跳槽到更有前景的公司',
                '【转型】转行/转型到更感兴趣的领域',
                '【副业】找到第二条收入线/发展线',
                '【平衡】兼顾家庭/孩子，平衡发展',
                '【创业】创业，带领团队取得突破',
                '其它'
            ],
            // 是否愿意担任组长
            leader_group:['愿意','不愿意'],
            advantage_group:[
                '有专业生涯规划背景',
                '有社群运营经验',
                '时间充裕',
                '做事细心，有耐心',
                '其它'
            ],
            // 
            info:{
                job:'',
                workage:[],
                problem:[],
                target:[],
                income:[],
                target_income:[],
                familiar:[],
                advantage:[],
                leader:'',
                others:''
            },
            // 复选框
            problem_name:'',
            target_name:'',
            familiar_name:'',
            advantage_name:'',
            // 下拉框
            income_name:'',
            target_income_name:'',
            obj:{},
            class:''
        }
    },
    computed:{
        // 验证
        validation(){
            if(
              this.info.job &&
              this.info.workage.length>0 &&
              this.info.income.length>0 && 
              this.info.target_income.length>0 && 
              this.info.leader && 
              this.info.problem.length>0 && 
              this.info.target.length>0 && 
              this.info.others && 
              this.info.familiar.length>0 &&
            //   判断是否选择其它
              (
                (this.info.problem.includes('其它')?(this.problem_name?true:false):true) &&
                (this.info.target.includes('其它')?(this.target_name?true:false):true) &&
                (this.info.familiar.includes('其它')?(this.familiar_name?true:false):true) &&
                (this.info.income.includes('其它')?(this.income_name?true:false):true) &&
                (this.info.target_income.includes('其它')?(this.target_income_name?true:false):true) &&
            // 判断如果愿意担任组长
                (
                    this.info.leader=='愿意'?(
                        this.info.advantage.includes('其它')?(this.advantage_name?true:false):(this.info.advantage.length>0?true:false)
                    ):true
                    
                )
              )

            ){
                return true;
            }
            return false;
        }
    },
    methods:{
        // 获得焦点时选中
        addCheckbox(name,e){
            if (e && e.stopPropagation) {//非IE浏览器 
        　　    e.stopPropagation(); 
            } 
        },
        // 处理其它
        otherHandle(){
            let keys = Object.keys(this.info);
            let info = deepCopy(this.info);
            if(this.info.problem.indexOf('其它')>0){
                let index = this.info.problem.indexOf('其它');
                info.problem[index] = '其它:'+this.problem_name;
            }
            if(this.info.target.indexOf('其它')>0){
                let index = this.info.target.indexOf('其它');
                info.target[index] = '其它:'+this.target_name;
            }
            if(this.info.familiar.indexOf('其它')>0){
                let index = this.info.familiar.indexOf('其它');
                info.familiar[index] = '其它:'+this.familiar_name;
            }
            // 愿意担任组长
            if(this.info.leader=='愿意'){
                if(this.info.advantage.indexOf('其它')>0){
                    let index = this.info.advantage.indexOf('其它');
                    info.advantage[index] = '其它:'+this.advantage_name;
                }
            }
            for(let i =0;i<keys.length;i++){
                if(info[keys[i]] instanceof Array){
                    info[keys[i]] = info[keys[i]].join('//');
                }
            }
            if(this.info.income.includes('其它')){
                info.income = '其它:'+this.income_name;
            }
            if(this.info.target_income.includes('其它')){
                info.target_income = '其它:'+this.target_income_name;
            }
            this.obj = info;
            if(this.info.leader=='不愿意'){
                this.obj.advantage = '';
            }
        },
        // 提交数据
        submitHandle(){
            if(!this.validation){
                this.$toast('请检查数据是否为空哦！');
                return
            }
            this.otherHandle();
            this.obj['md5'] = this.$route.query.md5;
            updateFormSubmit(this.obj).then((data)=>{
                if (data.code && String(data.code) === 10002) {
                    this.$toast(data.data.msg);
                    return;
                }
                this.$toast({
                    message: '提交成功!',
                    duration:1000,
                    onClose:()=>{
                        this.$router.push({
                            path:'/classInfor_success',
                            query:{
                                title:`《新精英特训营${this.class}班入学报到》`
                            }
                        });
                    }
                });
            });
        },
        // 弹出窗确认值
        confirm(data){
            // 截取弹窗类型指定字符前的字符，并赋值
            this.info[this.picker_type.split('_group')[0]] = data;
            this.picker_show=false;

        },
        // 获得弹出窗类型
        pickerType(type){
            this.picker_type=type;
            this.picker_show=true;

        },
        // 截取判断是否有其它
        isOther(list,name){
            let arr = list.split('//');
            if(list.length==0){
                return []
            }
            for(let i = 0; i<arr.length;i++){

                if(arr[i].indexOf('其它')>=0){
                    this[name] = arr[i].split(':')[1];
                    arr[i] = '其它';
                }
            }
            
            return arr;
        },
        pullData(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            getFormSubmit({
                md5:this.$route.query.md5
            }).then((data)=>{
                if(data.code && data.code ===10002){
                    this.$toast(data.msg);
                    return
                }
                this.class = data.class;
                document.title = `《新精英特训营${data.class}班入学报到》`;
                this.user = data.user;
                // 循环生成工作年限
                if(this.columns.workage_group.length<21){
                    for(let i=1;i<=20;i++){
                        if(i==20){
                            this.columns.workage_group.push(i+'年以上');
                        }else{
                            this.columns.workage_group.push(i+'年');
                        }
                    }
                }
                let s = data.submit;
                if(s){
                    this.info = {
                        job:s.job,
                        workage:s.workage.split(),
                        problem:this.isOther(s.problem,'problem_name'),
                        target:this.isOther(s.target,'target_name'),
                        income:this.isOther(s.income,'income_name'),
                        target_income:this.isOther(s.target_income,'target_income_name'),
                        familiar:this.isOther(s.familiar,'familiar_name'),
                        advantage:this.isOther(s.advantage,'advantage_name'),
                        leader:s.leader,
                        others:s.others,
                    };
                    this.income_name =s.income.indexOf('其它')>-1?s.income.split(':')[1]:'';
                    this.target_income_name =s.target_income.indexOf('其它')>-1?s.target_income.split(':')[1]:'';
                }

                this.columns.income_group.push('其它');
                this.columns.target_income_group.push('其它');
                this.body_show = true;
                this.$toast.clear();
            });
              
        }
    },
    created(){
        this.pullData();
        shareCon("training", this);
    }
}
</script>

<style lang="scss" scoped>
.training-main{
    padding: 30px 0 80px;
    h2.title{
        margin-bottom: 28px;
        padding: 0 30px;
        font-size:32px;
        color: #333333;
        line-height: 42px;
        text-align: justify;
    }
    h2.title2{
        margin-bottom: 60px;
        padding: 0 30px;
        font-size:32px;
        line-height: 42px;
        text-align: justify;
        color: #EB5032;
    }
}
.style_tags{
    color: #333;
    h2{
        margin-bottom: 30px;
        font-size: 32px;
        text-align: left;
        line-height: 42px;
        font-weight: normal;
        small{
            font-size: 24px;
            color: #666666;
        }
    }
    .training-other{
        line-height: 70px;
        padding: 0 0 0 8px;
        border:2px solid rgba(204,204,204,1);
        border-radius:8px;
        flex: 1;
        margin-left: 38px;
    }
}
.nickName{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 30px;
    font-size: 32px;
    color: #333333;
    label.title{
        width: 146px;
    }
    label.name{
        padding-left: 20px;
    }
}
.grouping{
    h4.h4{
        font-size: 32px;
        color: #333333;
        margin-bottom: 14px;
    }
    .choose_lable{
        top: auto;
        bottom: 27.5px;
    }
    .class_info_textarea{
        height: 144px;
        padding: 22px;
        border: 2px solid #cccccc;
        border-radius:8px;
        background-color: #ffffff;
        font-size: 26px;
    }
}
.btn{
    display: block;
    text-align: center;
    margin: 80px auto 0;
    width:174px;
    height:66px;
    line-height:66px;
    background-color: #CCCCCC;
    border-radius:33px;
    color: #fff;
    font-size:34px;
}
.btn.on{
    background:#EB5032;
}
</style>
<style lang="scss">
.class-information .grouping .van-cell .van-field__label{
    text-align: justify;
    white-space: nowrap
}
// 风格标签
.style_tags .van-checkbox-group,.style_tags  .radio-box .van-radio-group{
    .van-checkbox,.van-radio{
        font-size: 26px;
        margin-bottom: 20px;
        display: flex;
    }
    .van-checkbox.last-checkbox,.van-radio.last-checkbox,.van-radio.last-radio,.van-radio.last-radio{
        display: flex;
        align-items: center;
        line-height: 70px;
        margin-bottom: 0;
        text-align: justify;
        align-items: center;
    }
    .van-checkbox .van-checkbox__label,.van-radio .van-radio__label{
        position: relative;
        align-items: center;
        line-height: 40px;
        display: flex;
        flex-wrap: wrap;
        flex: 1;
    }
    .van-checkbox .van-checkbox__icon,.van-radio .van-radio__icon{
        height: 34px;
        margin-top: 5px;
    }
    .van-checkbox .van-checkbox__icon .van-icon,.van-radio .van-radio__icon .van-icon{
        width:34px;
        height: 34px;
        border:0;
        border-radius: 0;
        border-color: transparent;
        background-color: transparent;
        background-image: url(../../../assets/normal.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/press.png);
    }
    .van-radio .van-radio__icon .van-icon{
        background-image: url(../../../assets/radio_.png);
    }
    .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/radio_active.png);
    }
    .van-checkbox .van-checkbox__icon .van-icon:before,.van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}
.style_tags  .radio-box .van-radio-group{
    
    
    .van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}

</style>
